module.exports = __webpack_public_path__ + "img/icon_mall_en.96e16128.svg";